import { render, staticRenderFns } from "./RaCard.vue?vue&type=template&id=452c4a5a&scoped=true"
import script from "./RaCard.vue?vue&type=script&lang=js"
export * from "./RaCard.vue?vue&type=script&lang=js"
import style0 from "./RaCard.vue?vue&type=style&index=0&id=452c4a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c4a5a",
  null
  
)

export default component.exports